module.exports = __webpack_public_path__ + "static/media/arrow.e1d1446b.png";